import { Pipe, PipeTransform, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { GroupedUnassignedUserDataV2 } from '@wilson/interfaces';
import { ShiftTimelineUnassignedRegionState } from '@wilson/shift-timeline/state';
import { DateTimeFormat } from '@wilson/utils';
import { format } from 'date-fns';

@Pipe({
  name: 'toServiceFilterData',
  standalone: true,
})
export class ToServiceFilterDataPipe implements PipeTransform {
  private store = inject(Store);

  transform(groupedUnassignedUserData: GroupedUnassignedUserDataV2[] | null) {
    const serviceData: { id: string; name: string }[] = [];

    if (groupedUnassignedUserData) {
      groupedUnassignedUserData.forEach((data) => {
        data.services.forEach((service) => {
          const serviceObject = this.store.selectSnapshot(
            ShiftTimelineUnassignedRegionState.getService(service.id),
          );
          if (serviceObject) {
            serviceData.push({
              id: serviceObject.id,
              name: `${serviceObject.name} - ${format(
                new Date(serviceObject.startDate),
                DateTimeFormat.DayAndMonth,
              )}`,
            });
          }
        });
      });
    }

    return serviceData;
  }
}
